import $ from "./jquery-global.js";

import coreUtils from "./core-utils.js";
import accordionInit from "./ui/accordion.js";
import revealInit from "./ui/reveal.js";
import tabsInit from "./ui/tabs.js";
import coreScrollToTop from "../../components/molecules/scroll-to-top/scroll-to-top.js";
import advancedEditorialBlock from "../../components/organisms/advanced-editorial-block/advanced-editorial-block.js";
import advancedHeroSection from "../../components/organisms/advanced-hero-section/advanced-hero-section.js";
// import bonusCalculatorSection from "../../components/organisms/bonus-calculator-section/_bonus-calculator-section.js";
import cardHeroSection from "../../components/organisms/card-hero-section/card-hero-section.js";
import coBrandCardHeroSection from "../../components/organisms/co-brand-card-hero-section/co-brand-card-hero-section.js";
import compareCardsTableFunction from "../../components/organisms/compare-cards-table/compare-cards-table.js";
import CookiePage, {
  isCookieDialogOpen,
} from "../../components/organisms/cookie-consent/cookie-consent-dialog.js";
import trackingInit from "../../components/organisms/cookie-consent/tracking.js";
import crossSiteTracking from "../../components/organisms/cross-site-tracking/cross-site-tracking.js";
import editorialFeatureSection from "../../components/organisms/editorial-feature-section/editorial-feature-section.js";
import coreEditorialSection from "../../components/organisms/editorial-section/editorial-section.js";
import coreFAQSection from "../../components/organisms/faq-section/faq-section.js";
import heroBlock from "../../components/organisms/hero-block/hero-block.js";
import coreImageFeaturelist from "../../components/organisms/image-feature-list-section/image-feature-list-section.js";
import pageHeader from "../../components/organisms/page-header/page-header.js";
// import pageSpendwise from "../../components/organisms/page-spendwise/page-spendwise.js";
import pageSubNav from "../../components/organisms/page-sub-nav/page-sub-nav.js";
import revealTube from "../../components/organisms/reveal-tube/reveal-tube.js";
import videoSection from "../../components/organisms/video-section/video-section.js";

const originOf = (url) => {
  try {
    return new URL(url, window.location.href).origin;
  } catch {
    return null;
  }
};


let isSticky = false;
const essoStickyHeader = (scroll) => {
  const shouldStick = scroll >= 153;
  if (shouldStick === isSticky) {
    return;
  }
  isSticky = shouldStick;

  const sticky = $(".page-header");

  if (shouldStick) {
    if (!$(".page-pusher").length) {
      const height = sticky.outerHeight();
      $(
        `<div class="page-pusher" style="height: ${height}px"></div>`,
      ).insertBefore(".page-header");
    }
    $(".page-pusher").show();
    sticky.addClass("page-header--sticky");
  } else {
    $(".page-pusher").hide();
    sticky.removeClass("page-header--sticky");
  }
};

const openEssoMobileMenu = () => {
  $(".fullscreen-mobile-menu__open").on("click", () => {
    $(".fullscreen-mobile-menu").addClass("show");

    $("body").addClass("lock-scroll");
  });
};

const closeEssoMobileMenu = () => {
  $(".fullscreen-mobile-menu__close").on("click", () => {
    $(".fullscreen-mobile-menu").removeClass("show");
    $("body").removeClass("lock-scroll");
  });
};

// All components
const allComponents = () => {
  accordionInit();
  tabsInit();
  revealInit();

  // Inject SVG sprite sheets
  coreUtils.loadSVGSpritesheet("/Static/images/icons.svg", "icons");

  // Init local components
  openEssoMobileMenu();
  closeEssoMobileMenu();
  coreUtils.init(".page-sub-nav", pageSubNav);
  coreUtils.init(".card-hero-section", cardHeroSection);
//   coreUtils.init(".bonus-calculator-section", bonusCalculatorSection);
  coreUtils.init(".co-brand-card-hero-section", coBrandCardHeroSection);
  coreUtils.init(".video-section", videoSection);
  coreUtils.init(".advanced-hero-section", advancedHeroSection);
//   coreUtils.init(".sw-scroll-background", pageSpendwise);
  coreUtils.init("body", crossSiteTracking);
  coreUtils.init(".video-modal-closed", revealTube);
  coreUtils.init(".alertbar", pageHeader);
  coreUtils.init(".advanced-editorial-block", advancedEditorialBlock);
  coreUtils.init(".compare-cards-table__row-column", compareCardsTableFunction);

  // detect keyboard / screen reader or not
  document.body.classList.add("mouse"); // default
  document.addEventListener("keyup", (e) => {
    if (e.key === "Tab" && !e.altKey) {
      document.body.classList.add("keyboard");
      document.body.classList.remove("mouse");
    }
  });
  const onIsMouse = () => {
    document.body.classList.remove("keyboard");
    document.body.classList.add("mouse");
  };
  document.body.addEventListener("mousemove", onIsMouse, { passive: true });
  document.addEventListener("mousedown", onIsMouse);

  CookiePage();
  trackingInit();

  // FE-core items
  coreUtils.init(".scroll-to-top", coreScrollToTop);
  coreUtils.init(".editorial-section", coreEditorialSection);
  coreUtils.init(".faq-section", coreFAQSection);
  coreUtils.init(".new-hero-block", heroBlock);
  coreUtils.init(".image-feature-list-section", coreImageFeaturelist);
  coreUtils.init(".editorial-feature-section", editorialFeatureSection);

  const removeBadArias = () => {
    const badArias = document.querySelectorAll("[aria-label]:empty");
    badArias.forEach((el) => {
      el.removeAttribute("aria-label");
    });
  };
  const watchForJSRenderedElements = (cb) => {
    const config = {
      attributes: false,
      characterData: true,
      subtree: true,
      childList: true,
    };
    const targetNodes = document.querySelectorAll(".faq-section");
    targetNodes.forEach((targetNode) => {
      let debounceTimer;
      const callback = (mutationList) => {
        mutationList.forEach(() => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            cb();
          }, 500);
        });
      };
      const observer = new MutationObserver(callback.bind(this));
      observer.observe(targetNode, config);
    });
  };
  removeBadArias();
  watchForJSRenderedElements(removeBadArias);

  coreUtils.iFrameHeight();

  window.addEventListener("message", (event) => {
    const iframe = document.querySelector(".apply-section-iframe");
    // The application form lives on another domain, so only trust messages from
    // the origin that iframe was actually loaded from.
    if (!iframe || event.origin !== originOf(iframe.src)) {
      return;
    }
    if (event.data === "scrollTopOfOA") {
      window.scrollTo(0, iframe.offsetTop - 80);
    }
  });

  const delay = 1500;
  const ease = "swing";
  coreUtils.scrollToId(
    delay,
    ease,
    ":not(.accordion-title):not(.tabs-link):not(.native-anchor)",
    (e, linkValue) => {
      if (isCookieDialogOpen()) {
        return;
      }
      if (!$(linkValue).length) {
        return;
      }
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: `${$(linkValue).offset().top}px`,
        },
        delay,
        ease,
      );
    },
  );
  // coreUtils.setBackButtonUrl();
  coreUtils.addSpanToButtons();
};

let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
const isEssoSkin = document.body.classList.contains("skin-esso");

const onScroll = () => {
  const currScrollTop =
    window.pageYOffset || document.documentElement.scrollTop;

  if (isEssoSkin) {
    essoStickyHeader(currScrollTop);
  }

  if (currScrollTop > lastScrollTop) {
    document.body.classList.add("scroll-down");
    document.body.classList.remove("scroll-up");
  } else {
    document.body.classList.remove("scroll-down");
    document.body.classList.add("scroll-up");
  }
  lastScrollTop = Math.max(currScrollTop, 0); // For Mobile or negative scrolling
};

// Scroll events fire in bursts (e.g. while the accordion collapses), so coalesce
// them into one layout read/write per frame.
let scrollScheduled = false;
const onScrollFrame = () => {
  if (scrollScheduled) {
    return;
  }
  scrollScheduled = true;
  requestAnimationFrame(() => {
    scrollScheduled = false;
    onScroll();
  });
};

// Init all scripts
allComponents();

window.addEventListener("scroll", onScrollFrame, { passive: true });
